import { createClient } from '@supabase/supabase-js';

// TODO: Replace these with your actual Supabase project details
// Example: https://xyz.supabase.co
export const SUPABASE_PROJECT_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const SUPABASE_BUCKET_NAME = process.env.REACT_APP_SUPABASE_BUCKET_NAME || 'videos';

export const supabase = createClient(SUPABASE_PROJECT_URL, SUPABASE_ANON_KEY);

export const getSupabaseVideoUrl = (path) => {
    if (!path) return '';

    // Remove leading slash if present for the storage path
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;

    const { data } = supabase
        .storage
        .from(SUPABASE_BUCKET_NAME)
        .getPublicUrl(cleanPath);

    return data.publicUrl;
};
